/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './search.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from './utils.service';
import * as import9 from './search.service';
import * as import10 from './search-elasticsearch.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/router/src/router';
import * as import13 from '@angular/core/src/metadata/view';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from './assets/css/search.css.shim';
import * as import16 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import17 from '../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import18 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import19 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import20 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import21 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import23 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import24 from '@angular/core/src/linker/element_ref';
import * as import25 from '@angular/core/src/linker/template_ref';
import * as import26 from '@angular/common/src/directives/ng_class';
import * as import27 from '@angular/forms/src/directives/default_value_accessor';
import * as import28 from '@angular/forms/src/directives/control_value_accessor';
import * as import29 from '@angular/forms/src/directives/ng_model';
import * as import30 from '@angular/forms/src/directives/ng_control';
import * as import31 from '@angular/forms/src/directives/ng_control_status';
import * as import32 from '@angular/forms/src/directives/ng_form';
import * as import33 from '@angular/forms/src/directives/control_container';
import * as import34 from '@angular/common/src/directives/ng_if';
import * as import35 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import36 from '@angular/common/src/directives/ng_for';
export class Wrapper_SearchComponent {
  context:import0.SearchComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this.changed = false;
    this.context = new import0.SearchComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  check_type(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.type = currValue;
      this._expr_0 = currValue;
    }
  }
  check_order(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.order = currValue;
      this._expr_1 = currValue;
    }
  }
  check_scrollOnClick(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.scrollOnClick = currValue;
      this._expr_2 = currValue;
    }
  }
  check_target(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.target = currValue;
      this._expr_3 = currValue;
    }
  }
  check_placeholder(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this.changed = true;
      this.context.placeholder = currValue;
      this._expr_4 = currValue;
    }
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_5 = currValue;
    }
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_6 = currValue;
    }
  }
  check_expand(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this.changed = true;
      this.context.expand = currValue;
      this._expr_7 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_SearchComponent_Host:import4.RenderComponentType = (null as any);
class _View_SearchComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _SearchComponent_0_4:Wrapper_SearchComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent_Host0,renderType_SearchComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'search',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_SearchComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchComponent_0_4 = new Wrapper_SearchComponent(this.parentInjector.get(import8.UtilsService),this.parentInjector.get(import9.SearchService),this.parentInjector.get(import10.ElasticSearchService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import12.Router));
    this._appEl_0.initComponent(this._SearchComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._SearchComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchComponent) && (0 === requestNodeIndex))) { return this._SearchComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_SearchComponent_Host === (null as any))) { (renderType_SearchComponent_Host = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_SearchComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const SearchComponentNgFactory:import14.ComponentFactory<import0.SearchComponent> = new import14.ComponentFactory<import0.SearchComponent>('search',viewFactory_SearchComponent_Host0,import0.SearchComponent);
const styles_SearchComponent:any[] = [import15.styles];
var renderType_SearchComponent:import4.RenderComponentType = (null as any);
class _View_SearchComponent0 extends import3.AppView<import0.SearchComponent> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _NgClass_3_3:import16.Wrapper_NgClass;
  _NgForm_3_4:import17.Wrapper_NgForm;
  _ControlContainer_3_5:any;
  _NgControlStatusGroup_3_6:import18.Wrapper_NgControlStatusGroup;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _NgClass_7_3:import16.Wrapper_NgClass;
  _DefaultValueAccessor_7_4:import19.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_7_5:any[];
  _NgModel_7_6:import20.Wrapper_NgModel;
  _NgControl_7_7:any;
  _NgControlStatus_7_8:import18.Wrapper_NgControlStatus;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _appEl_17:import5.AppElement;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import21.Wrapper_NgIf;
  _text_18:any;
  _map_32:any;
  /*private*/ _expr_33:any;
  _map_34:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent0,renderType_SearchComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_32 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {hide: p0};
    });
    this._expr_33 = import1.UNINITIALIZED;
    this._map_34 = import2.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'search-box': p0,
        'search-box-expand': p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import2.createRenderElement(this.renderer,parentRenderNode,'div',new import2.InlineArray2(2,'class','search-c widget'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_3 = import2.createRenderElement(this.renderer,this._el_0,'form',new import2.InlineArray4(4,'autocomplete','off','class','sidebar-form'),(null as any));
    this._NgClass_3_3 = new import16.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers),this.parentInjector.get(import23.KeyValueDiffers),new import24.ElementRef(this._el_3),this.renderer);
    this._NgForm_3_4 = new import17.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_3_5 = this._NgForm_3_4.context;
    this._NgControlStatusGroup_3_6 = new import18.Wrapper_NgControlStatusGroup(this._ControlContainer_3_5);
    this._text_4 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_3,'div',new import2.InlineArray2(2,'class','input-group'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_7 = import2.createRenderElement(this.renderer,this._el_5,'input',new import2.InlineArray8(8,'class','form-control search-input','id','search-box','name','search','type','text'),(null as any));
    this._NgClass_7_3 = new import16.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers),this.parentInjector.get(import23.KeyValueDiffers),new import24.ElementRef(this._el_7),this.renderer);
    this._DefaultValueAccessor_7_4 = new import19.Wrapper_DefaultValueAccessor(this.renderer,new import24.ElementRef(this._el_7));
    this._NG_VALUE_ACCESSOR_7_5 = [this._DefaultValueAccessor_7_4.context];
    this._NgModel_7_6 = new import20.Wrapper_NgModel(this._ControlContainer_3_5,(null as any),(null as any),this._NG_VALUE_ACCESSOR_7_5);
    this._NgControl_7_7 = this._NgModel_7_6.context;
    this._NgControlStatus_7_8 = new import18.Wrapper_NgControlStatus(this._NgControl_7_7);
    this._text_8 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._el_9 = import2.createRenderElement(this.renderer,this._el_5,'button',new import2.InlineArray8(6,'class','search-button','name','search','type','submit'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._el_11 = import2.createRenderElement(this.renderer,this._el_9,'i',new import2.InlineArray2(2,'class','fa fa-search search-icon'),(null as any));
    this._text_12 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._text_14 = this.renderer.createText(this._el_3,'\n    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_17 = new import5.AppElement(17,0,this,this._anchor_17);
    this._TemplateRef_17_5 = new import25.TemplateRef_(this._appEl_17,viewFactory_SearchComponent1);
    this._NgIf_17_6 = new import21.Wrapper_NgIf(this._appEl_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(this._el_0,'\n\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'mouseout',this.eventHandler(this._handle_mouseout_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'mouseover',this.eventHandler(this._handle_mouseover_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_3,'submit',this.eventHandler(this._handle_submit_3_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_3,'reset',this.eventHandler(this._handle_reset_3_1.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_7,'click',this.eventHandler(this._handle_click_7_0.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_7,'keyup',this.eventHandler(this._handle_keyup_7_1.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_7,'ngModelChange',this.eventHandler(this._handle_ngModelChange_7_2.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_7,'input',this.eventHandler(this._handle_input_7_3.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_7,'blur',this.eventHandler(this._handle_blur_7_4.bind(this)));
    const subscription_0:any = this._NgModel_7_6.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_7_2.bind(this)));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._anchor_17,
      this._text_18
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.NgClass) && (7 === requestNodeIndex))) { return this._NgClass_7_3.context; }
    if (((token === import27.DefaultValueAccessor) && (7 === requestNodeIndex))) { return this._DefaultValueAccessor_7_4.context; }
    if (((token === import28.NG_VALUE_ACCESSOR) && (7 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_7_5; }
    if (((token === import29.NgModel) && (7 === requestNodeIndex))) { return this._NgModel_7_6.context; }
    if (((token === import30.NgControl) && (7 === requestNodeIndex))) { return this._NgControl_7_7; }
    if (((token === import31.NgControlStatus) && (7 === requestNodeIndex))) { return this._NgControlStatus_7_8.context; }
    if (((token === import26.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._NgClass_3_3.context; }
    if (((token === import32.NgForm) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._NgForm_3_4.context; }
    if (((token === import33.ControlContainer) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._ControlContainer_3_5; }
    if (((token === import31.NgControlStatusGroup) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._NgControlStatusGroup_3_6.context; }
    if (((token === import25.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import34.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = 'sidebar-form';
    this._NgClass_3_3.check_klass(currVal_3_0_0,throwOnChange,false);
    const currVal_3_0_1:any = this._map_32((this.context.type == 'global'));
    this._NgClass_3_3.check_ngClass(currVal_3_0_1,throwOnChange,false);
    this._NgClass_3_3.detectChangesInInputProps(this,this._el_3,throwOnChange);
    this._NgForm_3_4.detectChangesInInputProps(this,this._el_3,throwOnChange);
    this._NgControlStatusGroup_3_6.detectChangesInInputProps(this,this._el_3,throwOnChange);
    const currVal_7_0_0:any = 'form-control search-input';
    this._NgClass_7_3.check_klass(currVal_7_0_0,throwOnChange,false);
    const currVal_7_0_1:any = this._map_34(!this.context.expand,this.context.expand);
    this._NgClass_7_3.check_ngClass(currVal_7_0_1,throwOnChange,false);
    this._NgClass_7_3.detectChangesInInputProps(this,this._el_7,throwOnChange);
    this._DefaultValueAccessor_7_4.detectChangesInInputProps(this,this._el_7,throwOnChange);
    const currVal_7_2_0:any = 'search';
    this._NgModel_7_6.check_name(currVal_7_2_0,throwOnChange,false);
    const currVal_7_2_1:any = this.context.formQuery;
    this._NgModel_7_6.check_model(currVal_7_2_1,throwOnChange,false);
    this._NgModel_7_6.detectChangesInInputProps(this,this._el_7,throwOnChange);
    this._NgControlStatus_7_8.detectChangesInInputProps(this,this._el_7,throwOnChange);
    const currVal_17_0_0:any = this.context.suggestions;
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.detectChangesInInputProps(this,this._anchor_17,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_3_3.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this._NgForm_3_4.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this._NgControlStatusGroup_3_6.detectChangesInHostProps(this,this._el_3,throwOnChange);
    const currVal_33:any = import2.interpolate(1,'',this.context.placeholder,'...');
    if (import2.checkBinding(throwOnChange,this._expr_33,currVal_33)) {
      this.renderer.setElementProperty(this._el_7,'placeholder',currVal_33);
      this._expr_33 = currVal_33;
    }
    this._NgClass_7_3.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this._DefaultValueAccessor_7_4.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this._NgModel_7_6.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this._NgControlStatus_7_8.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_7_6.context.ngOnDestroy();
  }
  private _handle_mouseout_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.context.onSearchLeave()) !== false);
    return (true && pd_0_0);
  }
  private _handle_mouseover_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.context.onSearchOver()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_3_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_3_0:any = ((<any>this.context.onSubmit()) !== false);
    const pd_3_1:any = ((<any>this._NgForm_3_4.context.onSubmit($event)) !== false);
    return ((true && pd_3_0) && pd_3_1);
  }
  private _handle_reset_3_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_3_0:any = ((<any>this._NgForm_3_4.context.onReset()) !== false);
    return (true && pd_3_0);
  }
  private _handle_click_7_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>this.context.onInputClick(this._el_7.value,$event)) !== false);
    return (true && pd_7_0);
  }
  private _handle_keyup_7_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>this.context.onInputChange(this._el_7.value,$event)) !== false);
    return (true && pd_7_0);
  }
  private _handle_ngModelChange_7_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>(this.context.formQuery = $event)) !== false);
    return (true && pd_7_0);
  }
  private _handle_input_7_3($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>this._DefaultValueAccessor_7_4.context.onChange($event.target.value)) !== false);
    return (true && pd_7_0);
  }
  private _handle_blur_7_4($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>this._DefaultValueAccessor_7_4.context.onTouched()) !== false);
    return (true && pd_7_0);
  }
}
export function viewFactory_SearchComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.SearchComponent> {
  if ((renderType_SearchComponent === (null as any))) { (renderType_SearchComponent = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.Emulated,styles_SearchComponent,{})); }
  return new _View_SearchComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_SearchComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import5.AppElement;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import21.Wrapper_NgIf;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _appEl_11:import5.AppElement;
  _TemplateRef_11_5:any;
  _NgFor_11_6:import35.Wrapper_NgFor;
  _text_12:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent1,renderType_SearchComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','suggestions'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','suggestion-search-msg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_2,'a',new import2.InlineArray2(2,'style','cursor: pointer'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5,(null as any));
    this._appEl_7 = new import5.AppElement(7,5,this,this._anchor_7);
    this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7,viewFactory_SearchComponent2);
    this._NgIf_7_6 = new import21.Wrapper_NgIf(this._appEl_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_5,'\n            ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_11 = new import5.AppElement(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import25.TemplateRef_(this._appEl_11,viewFactory_SearchComponent3);
    this._NgFor_11_6 = new import35.Wrapper_NgFor(this._appEl_11.vcRef,this._TemplateRef_11_5,this.parent.parentInjector.get(import22.IterableDiffers),this.parent.ref);
    this._text_12 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._anchor_11,
      this._text_12
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import34.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    if (((token === import25.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import36.NgFor) && (11 === requestNodeIndex))) { return this._NgFor_11_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7_0_0:any = ((<_View_SearchComponent0>this.parent)._el_7.value.length >= this.parent.context.suggestionTriggerThreshold);
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    const currVal_11_0_0:any = this.parent.context.order;
    this._NgFor_11_6.check_ngForOf(currVal_11_0_0,throwOnChange,false);
    this._NgFor_11_6.detectChangesInInputProps(this,this._anchor_11,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_SearchComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_SearchComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent2,renderType_SearchComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'span',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'i',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_5:any = import2.interpolate(1,'\n                    ',this.parent.parent.context.placeholder,' ');
    if (import2.checkBinding(throwOnChange,this._expr_5,currVal_5)) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
    const currVal_6:any = import2.interpolate(1,'"',(<_View_SearchComponent0>this.parent.parent)._el_7.value,'"');
    if (import2.checkBinding(throwOnChange,this._expr_6,currVal_6)) {
      this.renderer.setText(this._text_3,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_SearchComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent3,renderType_SearchComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import25.TemplateRef_(this._appEl_2,viewFactory_SearchComponent4);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import34.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (this.parent.parent.context.suggestions[this.context.$implicit].length > 0);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_SearchComponent4 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import35.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_10:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent4,renderType_SearchComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_10 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'ul',new import2.InlineArray2(2,'class','col-sm-4'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'li',new import2.InlineArray2(2,'class','dropdown-header text-uppercase'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_5 = new import5.AppElement(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import25.TemplateRef_(this._appEl_5,viewFactory_SearchComponent5);
    this._NgFor_5_6 = new import35.Wrapper_NgFor(this._appEl_5.vcRef,this._TemplateRef_5_5,this.parent.parent.parent.parentInjector.get(import22.IterableDiffers),this.parent.parent.parent.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import36.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_5_0_0:any = this.parent.parent.parent.context.suggestions[this.parent.context.$implicit];
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_10:any = import2.interpolate(1,'',(this.parent.parent.parent.context.labels? this.parent.parent.parent.context.labels[this.parent.context.$implicit][this.parent.parent.parent.context.language]: this.parent.context.$implicit),'');
    if (import2.checkBinding(throwOnChange,this._expr_10,currVal_10)) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_SearchComponent5 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  /*private*/ _expr_9:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchComponent5,renderType_SearchComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_8 = import1.UNINITIALIZED;
    this._expr_9 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'class','pointer'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_2,'small',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_8:any = import2.interpolate(1,'\n                        ',this.context.$implicit.name,' ');
    if (import2.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_9:any = import2.interpolate(1,'(',this.context.$implicit.freq,')');
    if (import2.checkBinding(throwOnChange,this._expr_9,currVal_9)) {
      this.renderer.setText(this._text_5,currVal_9);
      this._expr_9 = currVal_9;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.parent.context.onSuggestSelect(this.parent.parent.context.$implicit,this.context.$implicit.name)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_SearchComponent5(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchComponent5(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search.component.ngfactory.ts